module.exports = __webpack_public_path__ + "img/stay.063cb98f.jpg";